export default __webpack_public_path__ + "static/media/E-Valuate.f3f4ad80.png";